<template>
  <div class="loading">
    <div class="loading-animation">
      <LoadingCircle class="loading-animation__image" />
      <div class="loading-animation__text" :style="{ '--color': color }">
        讀取中，請稍候
      </div>
    </div>

    <Overlay class="loading__overlay" light />
  </div>
</template>

<script>
import { computed } from 'vue';
import { useStore } from 'vuex';
import LoadingCircle from '../components/icons/LoadingCircle.vue';
import Overlay from './Overlay.vue';
export default {
  name: 'Loading',
  components: {
    Overlay,
    LoadingCircle,
  },
  setup() {
    const store = useStore();
    const color = computed(() => store.getters.getColor(2) || '#008CD6');

    return {
      color,
    };
  },
};
</script>

<style lang="scss" scoped>
.loading {
  background-color: burlywood;
  .loading-animation {
    text-align: center;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 10000;

    &__image {
      margin-bottom: 12px;
      animation: rolling 1200ms infinite;

      @keyframes rolling {
        from {
          transform: rotate(0deg);
        }
        to {
          transform: rotate(360deg);
        }
      }
    }

    &__text {
      color: var(--color);
    }
  }
}
</style>
